/**
 * Determines whether the session's elapsed minute count should be incremented
 * based on the current secondsRemaining and the initial timer duration.
 *
 * Increments happen every completed minute (secondsRemaining % 60 === 0),
 * but NOT on the very first tick (i.e. when no seconds have elapsed yet).
 */
export const shouldIncrementMinute = (
  secondsRemaining: number,
  initialMinutes: number,
): boolean =>
  initialMinutes * 60 !== secondsRemaining && secondsRemaining % 60 === 0;
